import { React, Fragment, memo, useState, useEffect } from 'react'
import { HeadingText, BodyText, Link } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import asASlide from '../../common/as-a-slide'
import { PP_LOGGED_OUT_URL } from '../../../constants/constants'
import { fptiCustomSetup } from '../../../utils'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
const loggedOutFPTI = DATAPRIVACY_FPTI.LOGGED_OUT

const ConfirmYourEmail = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)
  const { modalParams: { email = '' } = {} } = props

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(loggedOutFPTI.CONFIRM_YOUR_MAIL_IMPRESSION)
    }
  }, [])

  return (
    <Fragment>
      <HeadingText
        id="confirmmail-header"
        size="md"
        className="text-center requestForm-row"
      >
        <Message id="dsrLoggedout.confirmmail.header" />
      </HeadingText>

      <BodyText className="dataPrivacy-row text-center">
        <Message
          id="dsrLoggedout.confirmmail.content"
          emailId={email}
          link={(innerMessage) => (
            <Link href={PP_LOGGED_OUT_URL} theme="v2">
              {innerMessage}
            </Link>
          )}
        />
      </BodyText>
    </Fragment>
  )
})
ConfirmYourEmail.displayName = 'ConfirmYourEmail'
export default asASlide({ position: 2 })(ConfirmYourEmail)
